<template>
  <bita-modal
    id="notice-form"
    :title="title"
    :modal-lg="true"
    :is-loading="isLoading"
    @close="reset"
  >
    <div slot="body">
      <bita-form ref="form">
        <div slot="body">
          <div class="row">
            <bita-input
              type="text"
              name="title"
              label="عنوان"
              rules="required"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="form.title"
            />

            <bita-select
              name="notice_type"
              label="نوع"
              rules="required"
              :validation-container-class="colWidth"
              :data-source="noticeTypes"
              data-text-field="name"
              data-value-field="id"
              v-model="form.notice_type"
            />

            <bita-input
              type="number"
              name="product_code"
              label="کد محصول"
              rules="required"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="form.product_code"
            />

            <bita-datepicker
              type="date"
              name="starts_at"
              label="تاریخ شروع"
              rules="required"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="form.starts_at"
              format="YYYY/MM/DD"
              display-format="jYYYY/jMM/jDD"
            />

            <bita-datepicker
              type="date"
              name="ends_at"
              label="تاریخ پایان"
              rules="required"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="form.ends_at"
              format="YYYY/MM/DD"
              display-format="jYYYY/jMM/jDD"
            />

            <div :class="colWidth">
              <label>وضعیت</label>
              <select v-model="form.status" class="form-control">
                <option value="draft">پیش‌نویس</option>
                <option value="published">فعال</option>
                <option value="closed">پایان‌یافته</option>
                <option value="cancelled">لغوشده</option>
              </select>
            </div>

            <div :class="colWidth">
              <label>فایل ضمیمه</label>
              <bita-uploader
                name="attachment_path"
                label="فایل"
                :validation-container-class="colWidth"
                input-class="form-control"
                v-model="form.attachment_path"
                :icon-url="form.attachment_path"
              />
            </div>

            <div class="col-lg-12">
              <label>توضیحات</label>
              <textarea v-model="form.description" class="form-control" rows="4"></textarea>
            </div>
          </div>
        </div>
      </bita-form>
    </div>

    <div slot="footer">
      <bita-bootbutton
        v-if="!form.id"
        type="primary"
        title="ذخیره"
        icon="fas fa-save"
        btn-width="150px"
        @click.native="save"
      />
      <bita-bootbutton
        v-else
        type="primary"
        title="بروزرسانی"
        icon="fas fa-save"
        btn-width="150px"
        @click.native="update"
      />
    </div>
  </bita-modal>
</template>

<script>
export default {
  props: {
    title: String,
    isLoading: Boolean,
    noticeTypes: Array,
    notice: Object,
  },
  data() {
    return {
      colWidth: 'col-lg-4',
      form: {},
    };
  },
  methods: {
    setFormData(formData) {
      this.form = { ...formData };
    },
    save() {
      this.$refs.form.validate().then((result) => {
        if (result) this.$emit('on-create', this.form);
      });
    },
    update() {
      this.$refs.form.validate().then((result) => {
        if (result) this.$emit('on-update', this.form);
      });
    },
    reset() {
      this.form = {
        notice_type: 'tender',
        status: 'draft',
      };

      this.$refs.form && this.$refs.form.reset();
      this.$refs.uploader && this.$refs.uploader.reset();
    },
    setErrors(_errors) {
      this.$refs.form.setErrors(_errors);
    },
  },
};
</script>